import { css } from 'styled-components';

export const firefox = css`
    /* prettier-ignore */
    @-moz-document url-prefix()
`;

export const chrome = css`
    /* prettier-ignore */
    @media screen and (-webkit-min-device-pixel-ratio: 0)
`;

export const ie = css`
    /* prettier-ignore */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)
`;
